import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useRoute } from 'vue-router/composables';

import { WorkflowId, WorkflowNodeId } from '@ply-io/ply-front-shared-utilities';

// import Footer from './Footer.vue';
import RightSidePanel from './RightSidePanel.vue';
import CreateSubflowFooter from '../helpers/CreateSubflowFooter.vue';
import MoveStepFooter from '../helpers/MoveStepFooter.vue';
import FlowTree from '@/components/FlowTree/FlowTree.vue';
import { useWorkflowsGetters, useSelectedNodeActions } from '@/store-composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'InterfaceFocusedFlow',
  props: {
    workflowId: null,
    hasLoadedNodesData: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { workflowId: WorkflowId; hasLoadedNodesData: boolean }

const route = useRoute();
const nodeId = computed<WorkflowNodeId | string | undefined>(() => {
	if (!route.params.nodeID) {
		return undefined;
	}
	const parsedNodeId = parseInt(route.params.nodeID);
	if (Number.isNaN(parsedNodeId)) {
		return route.params.nodeID;
	} else {
		return parsedNodeId;
	}
});

const { getWorkflow } = useWorkflowsGetters();
const workflow = computed(() => {
	const wf = getWorkflow.value(props.workflowId);
	if (!wf) {
		throw new Error('Workflow not found');
	}
	return wf;
});
const { closeSideBar } = useSelectedNodeActions();

return { __sfc: true,route, nodeId, props, getWorkflow, workflow, closeSideBar, RightSidePanel, CreateSubflowFooter, MoveStepFooter, FlowTree }
}

})